export default {"src":"https://fishbrain.com/_next/static/media/third_quarter.4420f6c6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};